const BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const getToken = () => localStorage.getItem('kdx_token');

const api = async (path, options = {}) => {
  const token = getToken();
  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Server error');
  return data;
};

export const login = (body) => api('/api/auth/login', { method: 'POST', body: JSON.stringify(body) });
export const getMe = () => api('/api/auth/me');
export const changePassword = (body) => api('/api/auth/change-password', { method: 'POST', body: JSON.stringify(body) });

export const getShipments = (params = {}) => api(`/api/shipments?${new URLSearchParams(params)}`);
export const getStats = () => api('/api/shipments/stats');
export const getPendingByCustomer = () => api('/api/shipments/pending-by-customer');
export const mapCustomer = (id, customer_id) => api(`/api/shipments/${id}/map`, { method: 'PUT', body: JSON.stringify({ customer_id }) });
export const setDisposition = (shipment_ids, disposition) => api('/api/shipments/bulk-disposition', { method: 'PUT', body: JSON.stringify({ shipment_ids, disposition }) });
export const setWarehouse = (shipment_ids, warehouse) => api('/api/shipments/bulk-warehouse', { method: 'PUT', body: JSON.stringify({ shipment_ids, warehouse }) });
export const updateLocation = (id, current_location) => api(`/api/shipments/${id}/location`, { method: 'PUT', body: JSON.stringify({ current_location }) });
export const deleteShipment = (id) => api(`/api/shipments/${id}`, { method: 'DELETE' });

export const getUsers = (params = {}) => api(`/api/users?${new URLSearchParams(params)}`);
export const createUser = (body) => api('/api/users', { method: 'POST', body: JSON.stringify(body) });
export const updateUser = (id, body) => api(`/api/users/${id}`, { method: 'PUT', body: JSON.stringify(body) });
export const deleteUser = (id) => api(`/api/users/${id}`, { method: 'DELETE' });

export const getAliases = (params = {}) => api(`/api/aliases?${new URLSearchParams(params)}`);
export const createAlias = (body) => api('/api/aliases', { method: 'POST', body: JSON.stringify(body) });
export const deleteAlias = (id) => api(`/api/aliases/${id}`, { method: 'DELETE' });

export const getShipmentImages = (shipmentId) => api(`/api/shipment-images/${shipmentId}`);

export const countCansShipment = (id) => api(`/api/shipments/${id}/count-cans`, { method: 'POST' });
export const updateCanCount = (id, can_count) => api(`/api/shipments/${id}/can-count`, { method: 'PUT', body: JSON.stringify({ can_count }) });
export const recountAll = (body = {}) => api('/api/shipments/recount-all', { method: 'POST', body: JSON.stringify(body) });
export const getRecountStatus = () => api('/api/shipments/recount-status');
export const cancelRecount = () => api('/api/shipments/recount-cancel', { method: 'POST' });

export const getExpected = (params = {}) => api(`/api/expected?${new URLSearchParams(params)}`);
export const createExpected = (body) => api('/api/expected', { method: 'POST', body: JSON.stringify(body) });
export const deleteExpected = (id) => api(`/api/expected/${id}`, { method: 'DELETE' });
export const syncExpected = () => api('/api/expected/sync', { method: 'POST' });
export const syncWarehouse = (warehouse) => api('/api/expected/sync-warehouse', { method: 'POST', body: JSON.stringify({ warehouse }) });
export const syncAll = () => api('/api/expected/sync-all', { method: 'POST' });
export const matchExpected = (id, shipment_id) => api(`/api/expected/${id}/match`, { method: 'PUT', body: JSON.stringify({ shipment_id }) });
export const getExpectedSummary = () => api('/api/expected/summary');

export const getFlights = () => api('/api/flights');
export const createFlight = (body) => api('/api/flights', { method: 'POST', body: JSON.stringify(body) });
export const updateFlightStatus = (id, status) => api(`/api/flights/${id}/status`, { method: 'PUT', body: JSON.stringify({ status }) });
export const deleteFlight = (id) => api(`/api/flights/${id}`, { method: 'DELETE' });
export const assignFlight = (flightId, shipment_ids) => api(`/api/flights/${flightId}/assign`, { method: 'PUT', body: JSON.stringify({ shipment_ids }) });
export const unassignFlight = (shipment_ids) => api('/api/flights/unassign', { method: 'PUT', body: JSON.stringify({ shipment_ids }) });
